import $ from './jquery';
import * as pushstream from './core/lp';
import Spaces from './spacesLib';
import notifications from './notifications';

function MsgFlowControl(options) {
	var self = this;
	
	var messages_queue = [],
		last_request,
		last_request_run,
		last_refresh_interval,
		last_refresh_time = Date.now(),
		uniq_id = '.msg_fc' + last_refresh_time,
		refresh_on_focus = false;

	init();
	
	function init() {
		options = $.extend({
			onCheck: null,
			onRequest: null,
			onRefresh: null,
			onReset: null,
			interval: 30 * 1000,
			focus: false // Обновлять только если вкладка сфокусирована
		}, options);
		
		if (options.focus) {
			$('body').on('focuswindow' + uniq_id, function () {
				if (refresh_on_focus) {
					refresh_on_focus = false;
					refreshMessages(true);
				}
			});
		}
		
		enableManualRefresh(!pushstream || !pushstream.avail());
		if (pushstream) {
			pushstream.on('connect', 'msg_fc' + uniq_id, function (e) {
				if (!e.first) {
					resetQueue();
					refreshMessages(true);
				}
				enableManualRefresh(false);
			}).on('disconnect', 'msg_fc' + uniq_id, function () {
				if (!pushstream.disabled()) {
					enableManualRefresh(true);
					resetQueue();
				}
			});
		}
	}
	
	function addToQueue(ids) {
		if (last_refresh_interval)
			return;
		
		for (var i = 0; i < ids.length; ++i) {
			if (!options.onCheck || options.onCheck(ids[i]))
				messages_queue.push(ids[i]);
		}
		
		if (!last_request_run && messages_queue.length) {
			if (options.focus && !notifications.isWindowActive()) {
				// Вкладка неактивна, обновим при следущюем фокусе
				refresh_on_focus = true;
				return;
			}
			
			// Получаем текущую очередь сообщений
			var messages = messages_queue;
			var pag = messages_queue.pag;
			
			resetQueue();
			
			last_request_run = true;
			last_request = options.onRequest({
				queue: messages,
				done: function () {
					last_request_run = false;
				},
				fail: function () {
					last_request_run = false;
					resetQueue();
					refreshMessages(true);
				}
			});
		}
	}
	
	function resetQueue(stop) {
		options.onReset && options.onReset();
		Spaces.cancelApi(last_request);
		last_request = false;
		last_request_run = false;
		messages_queue = [];
	}
	
	function enableManualRefresh(flag) {
		if (!flag == !last_refresh_interval)
			return;
		if (last_refresh_interval) {
			clearInterval(last_refresh_interval);
			last_refresh_interval = null;
		}
		if (flag) {
			last_refresh_interval = setInterval(function () {
				refreshMessages();
			}, options.interval / 4);
			last_refresh_time = Date.now();
		}
	}
	
	function refreshMessages(force) {
		var self = this;
		if (!last_request_run && (force || (last_refresh_interval && Date.now() - last_refresh_time >= options.interval))) {
			if (options.focus && !notifications.isWindowActive()) {
				refresh_on_focus = true;
				return;
			}
			
			last_request_run = true;
			last_request = options.onRefresh({
				done: function () {
					last_refresh_time = Date.now();
					last_request_run = false;
				},
				fail: function () {
					last_refresh_time = Date.now();
					last_request_run = false;
				},
				retry: function () {
					last_refresh_time = Date.now();
					last_request_run = false;
					refreshMessages(true);
				}
			});
		}
	}
	
	function destroy() {
		resetQueue();
		if (pushstream) {
			pushstream
				.off('connect', 'msg_fc' + uniq_id)
				.off('disconnect', 'msg_fc' + uniq_id);
		}
		$('body').off('focuswindow' + uniq_id);
		messages_queue = null;
	}
	
	self.get = addToQueue;
	self.destroy = destroy;
	self.refresh = function () {
		refreshMessages(true);
	};
}

export {MsgFlowControl};

